export default {
    modules: [
        {
            key: "input",
            title: "settingsFields.inputTitle",
            fields: [
                {
                    key: "text",
                    title: "settingsFields.input.textTitle",
                    description: "settingsFields.input.textDescription",
                    icon: "blockquote-left",
                    field: {
                        module: "input",
                        type: "text"
                    }
                },
                {
                    key: "text_i18n",
                    title: "settingsFields.input.textI18NTitle",
                    description: "settingsFields.input.textI18NDescription",
                    icon: "globe",
                    field: {
                        module: "input",
                        type: "text_i18n"
                    }
                },
                {
                    key: "number",
                    title: "settingsFields.input.numberTitle",
                    description: "settingsFields.input.numberDescription",
                    icon: "hash",
                    field: {
                        module: "input",
                        type: "number"
                    }
                },
                {
                    key: "date",
                    title: "settingsFields.input.dateTitle",
                    description: "settingsFields.input.dateDescription",
                    icon: "calendar-date",
                    field: {
                        module: "input",
                        type: "date"
                    }
                },
                {
                    key: "image",
                    title: "settingsFields.input.imageTitle",
                    description: "settingsFields.input.imageDescription",
                    icon: "image",
                    field: {
                        module: "input",
                        type: "image"
                    }
                },
                {
                    key: "email",
                    title: "settingsFields.input.emailTitle",
                    description: "settingsFields.input.emailDescription",
                    icon: "envelope",
                    field: {
                        module: "input",
                        type: "email"
                    }
                },
                {
                    key: "password",
                    title: "settingsFields.input.passwordTitle",
                    description: "settingsFields.input.passwordDescription",
                    icon: "asterisk",
                    field: {
                        module: "input",
                        type: "password"
                    }
                },
                {
                    key: "file",
                    title: "settingsFields.input.fileTitle",
                    description: "settingsFields.input.fileDescription",
                    icon: "file-earmark",
                    field: {
                        module: "input",
                        type: "file"
                    }
                },
                {
                    key: "enum",
                    title: "settingsFields.input.fileTitle",
                    description: "settingsFields.input.fileDescription",
                    icon: "file-earmark",
                    field: {
                        module: "list",
                        type: "file"
                    }
                }
            ]
        },
        {
            key: "image",
            title: "settingsFields.imageTitle",
            fields: [
                {
                    key: "carousel",
                    title: "settingsFields.image.carouselTitle",
                    description: "settingsFields.image.textDescription",
                    icon: "images",
                    field: {
                        module: "image",
                        type: "carousel"
                    }
                }
            ]
        },
        {
            key: "text",
            title: "settingsFields.textTitle",
            fields: [
                {
                    key: "default",
                    title: "settingsFields.text.defaultTitle",
                    description: "settingsFields.text.defaultDescription",
                    icon: "card-text",
                    field: {
                        module: "text",
                        type: "default"
                    }
                },
                {
                    key: "editor",
                    title: "settingsFields.text.editorTitle",
                    description: "settingsFields.text.editorDescription",
                    icon: "layout-text-sidebar",
                    field: {
                        module: "text",
                        type: "editor"
                    }
                },
                {
                    key: "editor_i18n",
                    title: "settingsFields.text.editorTitle",
                    description: "settingsFields.text.editori18nDescription",
                    icon: "globe",
                    field: {
                        module: "text",
                        type: "editor_i18n"
                    }
                }
            ]
        },
        {
            key: "select",
            title: "settingsFields.selectTitle",
            fields: [
                {
                    key: "text",
                    title: "settingsFields.select.textTitle",
                    description: "settingsFields.select.textDescription",
                    icon: "list",
                    field: {
                        module: "select",
                        type: "text"
                    }
                },
                {
                    key: "number",
                    title: "settingsFields.select.numberTitle",
                    description: "settingsFields.select.numberDescription",
                    icon: "list-ol",
                    field: {
                        module: "select",
                        type: "number"
                    }
                },
                {
                    key: "image",
                    title: "settingsFields.select.imageTitle",
                    description: "settingsFields.select.imageDescription",
                    icon: "images",
                    field: {
                        module: "select",
                        type: "image"
                    }
                },
                {
                    key: "relation",
                    title: "settingsFields.select.relationTitle",
                    description: "settingsFields.select.relationDescription",
                    icon: "share",
                    field: {
                        module: "select",
                        type: "relation"
                    }
                },
                {
                    key: "external",
                    title: "settingsFields.select.externalTitle",
                    description: "settingsFields.select.externalDescription",
                    icon: "box-arrow-up-right",
                    field: {
                        module: "select",
                        type: "external"
                    }
                }
            ]
        },
        {
            key: "radio",
            title: "settingsFields.radioTitle",
            fields: [
                {
                    key: "text",
                    title: "settingsFields.radio.textTitle",
                    description: "settingsFields.radio.textDescription",
                    icon: "list-ul",
                    field: {
                        module: "radio",
                        type: "text"
                    }
                },
                {
                    key: "number",
                    title: "settingsFields.radio.numberTitle",
                    description: "settingsFields.radio.numberDescription",
                    icon: "list-ol",
                    field: {
                        module: "radio",
                        type: "number"
                    }
                },
               
            ]
        },
        {
            key: "checkbox",
            title: "settingsFields.checkboxTitle",
            fields: [
                {
                    key: "text",
                    title: "settingsFields.checkbox.textTitle",
                    description: "settingsFields.checkbox.textDescription",
                    icon: "list-ul",
                    field: {
                        module: "checkbox",
                        type: "text"
                    }
                },
                {
                    key: "number",
                    title: "settingsFields.checkbox.numberTitle",
                    description: "settingsFields.checkbox.numberDescription",
                    icon: "list-ol",
                    field: {
                        module: "checkbox",
                        type: "number"
                    }
                },
                {
                    key: "bool",
                    title: "settingsFields.checkbox.boolTitle",
                    description: "settingsFields.checkbox.boolDescription",
                    icon: "check",
                    field: {
                        module: "checkbox",
                        type: "bool"
                    }
                },
               
            ]
        },
        {
            key: "table",
            title: "settingsFields.tableTitle",
            fields: [
                {
                    key: "default",
                    title: "settingsFields.table.defaultTitle",
                    description: "settingsFields.table.defaultDescription",
                    icon: "table",
                    field: {
                        module: "table",
                        type: "default"
                    }
                },   
                {
                    key: "custom",
                    title: "settingsFields.table.customTitle",
                    description: "settingsFields.table.customDescription",
                    icon: "file-spreadsheet",
                    field: {
                        module: "table",
                        type: "custom"
                    }
                },              
            ]
        },
        {
            key: "picker",
            title: "settingsFields.pickerTitle",
            fields: [
                {
                    key: "date",
                    title: "settingsFields.picker.dateTitle",
                    description: "settingsFields.picker.dateDescription",
                    icon: "calendar-month",
                    field: {
                        module: "picker",
                        type: "date"
                    }
                }, 
                {
                    key: "daterange",
                    title: "settingsFields.picker.daterangeTitle",
                    description: "settingsFields.picker.daterangeDescription",
                    icon: "calendar-range",
                    field: {
                        module: "picker",
                        type: "daterange"
                    }
                },   
                {
                    key: "datetime",
                    title: "settingsFields.picker.datetimeTitle",
                    description: "settingsFields.picker.datetimeDescription",
                    icon: "clock",
                    field: {
                        module: "picker",
                        type: "datetime"
                    }
                },    
                {
                    key: "time",
                    title: "settingsFields.picker.timeTitle",
                    description: "settingsFields.picker.timeDescription",
                    icon: "clock-history",
                    field: {
                        module: "picker",
                        type: "time"
                    }
                },            
            ]
        },
        {
            key: "fieldset",
            title: "settingsFields.fieldsetTitle",
            fields: [
                {
                    key: "default",
                    title: "settingsFields.fieldset.defaultTitle",
                    description: "settingsFields.fieldset.defaultDescription",
                    icon: "border-inner",
                    field: {
                        module: "fieldset",
                        type: "default"
                    }
                }         
            ]
        },
        {
            key: "data",
            title: "settingsFields.dataTitle",
            fields: [
                {
                    key: "json",
                    title: "settingsFields.data.jsonTitle",
                    description: "settingsFields.data.jsonDescription",
                    icon: "braces",
                    field: {
                        module: "data",
                        type: "json"
                    }
                }         
            ]
        }
    ],
    constraints: {
        string: {
            required: false,
            placeholder: "",
            length: {
                min: null,
                max: null
            }
        },

        number: {
            required: false,
            placeholder: "",
            min: null,
            max: null
        }
    }
}

const defaultValueResolvers = {
    "data:json": function(d) {
        return JSON.parse(d)
    }
}

export {
    defaultValueResolvers
}